
const ClientRoutes = [
    {
        path: '',
        name: 'client-index',
        component: () => import("@/components/admin/client/list.vue"),
    },
    {
        path: 'list',
        name: 'list-client',
        component: () => import("@/components/admin/client/list.vue"),
    },
    {
        path: 'form',
        name: 'form-client',
        component: () => import("@/components/admin/client/form.vue"),
    }
];
export default ClientRoutes